import { useTranslation } from 'react-i18next';
import Icon from 'src/components/Icon';

export default function Error(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="container flex items-center justify-center py-32">
      <div className="flex flex-col items-center">
        <div className="">
          <Icon name="error" size="52" />
        </div>
        <div className="N_16_R text-black mt-5">{t('error/message_1')}</div>
        <div className="N_12_R text-brown-grey mt-1 text-center">{t('error/message_2')}</div>
      </div>
    </div>
  );
}
